var render = function render(){var _vm=this,_c=_vm._self._c;return _c('su-page',[_c('div',{staticClass:"mt30",attrs:{"slot":"content"},slot:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.details.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }